import React from 'react';

const SecondaryMobileButton = ({
  children,
  onClick,
  disabled = false,
  fullWidth = false,
  size = 'md',
  icon,
  type = 'button',
  className = '',
}) => {
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-5 py-3 text-sm',
    lg: 'px-6 py-3.5 text-base',
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        inline-flex items-center justify-center gap-2 font-semibold rounded-xl
        bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200
        border border-gray-200 dark:border-gray-700
        hover:bg-gray-200 dark:hover:bg-gray-700 active:scale-[0.98]
        transition-all duration-150
        disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100
        ${sizeClasses[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `}
    >
      {icon}
      {children}
    </button>
  );
};

export default SecondaryMobileButton;
